var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { t } from "i18next";
import { ComponentType, ComponentList, } from "./types";
import { defaultCupImageMap, piGripAddonPlaceholder } from "./constants";
import { ALWAYS_COMPATIBLE } from "3d/helpers";
import { getVacuumPumpImage, noCupMountingArticleNumber, } from "3d/constants/common";
/* Always interpret the longer side as "width" */
var getDimensionsFromLipSize = function (lipSize) {
    if (!lipSize)
        return { width: 0, height: 0 };
    var _a = __read(lipSize.split("x").map(Number), 2), dim1 = _a[0], dim2 = _a[1];
    var width = dim1 > dim2 ? dim1 : dim2;
    var height = dim1 > dim2 ? dim2 : dim1;
    return {
        width: width / 1000,
        height: height / 1000,
    };
};
var extractBaseComponent = function (group) {
    var members = group.members;
    var componentField = members[0];
    var validityField = members[1];
    return {
        articleNumber: componentField.properties.art_nr_code || "",
        link: componentField.properties.product_url || "",
        value: componentField.value,
        label: componentField.valueDescription,
        valid: validityField.value === "Yes",
    };
};
var extractSuctionCup = function (componentField, component, isObjectSurfaceOily) {
    var cupFamily = componentField.properties.cup_family;
    var mountingCompatibility = componentField.properties.fitting_mounting_interface;
    if (!cupFamily || !mountingCompatibility)
        return null;
    var defaultImage = defaultCupImageMap[cupFamily] || defaultCupImageMap["other"];
    var image = component.articleNumber
        ? "img/app/cups/" +
            component.articleNumber.replace(piGripAddonPlaceholder, "00") +
            ".png"
        : "img/app/cups/" + defaultImage;
    var surfaceType = isObjectSurfaceOily ? "oily" : "dry";
    return __assign(__assign(__assign({}, component), { cupFamily: cupFamily, size: componentField.properties.cup_size || undefined, material: componentField.properties.cup_material || undefined, hardness: componentField.properties.cup_hardness || undefined, bellows: componentField.properties.cup_bellows || undefined, image: image, horizontalLiftForce60: Number(componentField.properties["horizontal_".concat(surfaceType, "_lift_force_0_60")]), horizontalLiftForce90: Number(componentField.properties["horizontal_".concat(surfaceType, "_lift_force_61_90")]), verticalLiftForce60: Number(componentField.properties["vertical_".concat(surfaceType, "_lift_force_0_60")]), verticalLiftForce90: Number(componentField.properties["vertical_".concat(surfaceType, "_lift_force_61_90")]), mountingCompatibility: mountingCompatibility, modelCode: componentField.properties.suction_cup_id, volume: Number(componentField.properties.volume_dm3) || 0 }), getDimensionsFromLipSize(componentField.properties.lip_size_mm));
};
var extractVacuumPump = function (componentField, component) {
    var _a;
    var model = componentField.properties.pump_id;
    var cadName = componentField.properties.cad_name;
    if (!model || !cadName)
        return null;
    var pump = __assign(__assign({}, component), { model: model, family: (_a = componentField.properties.pump_family) !== null && _a !== void 0 ? _a : "", ejectorName: componentField.properties.ejector_name, functions: componentField.properties.functions, ejectorModel: componentField.properties.ejector_model, ejectorCount: componentField.properties.ejector_count
            ? Number.parseInt(componentField.properties.ejector_count)
            : 0, cadName: cadName, isEnergySavingAvailable: componentField.properties.toggle_es === "Yes", isInlineDecentralPump: componentField.properties.inline_decentral_pump === "Yes", recFeedPressureMpa: componentField.properties
            .rec_feed_pressure_mpa, volume: Number(componentField.properties.volume_dm3) || 0 });
    return __assign(__assign({}, pump), { image: getVacuumPumpImage(pump) });
};
var extractCupMounting = function (componentField, component) {
    var model = componentField.properties.mounting_type;
    var volume = Number(componentField.properties.volume_dm3);
    var diameter = Number(componentField.properties.outer_diameter_mm) / 1000;
    var suctionCupCompatibility = componentField.properties.fitting_mounting_interface;
    if (!diameter || !model || !volume || !suctionCupCompatibility)
        return null;
    return __assign(__assign({}, component), { model: model, volume: volume, diameter: diameter, suctionCupCompatibility: suctionCupCompatibility });
};
var extractCupTechnology = function (componentField, component) {
    var volume = Number(componentField.properties.volume_dm3);
    var diameter = Number(componentField.properties.outer_diameter_mm) / 1000;
    if (!diameter || !volume)
        return null;
    return __assign(__assign({}, component), { type: componentField.properties.technology_type, code: componentField.properties.code, color: componentField.properties.technology_color, cupTechId: componentField.properties.cup_tech_id, pigripCode: componentField.properties.pigrip_code, volume: volume, diameter: diameter });
};
export var getComponentFromTactonGroup = function (group, isObjectSurfaceOily) {
    var _a, _b;
    var component = extractBaseComponent(group);
    var componentField = group.members[0];
    var list = (_a = group.properties) === null || _a === void 0 ? void 0 : _a.component_list;
    var type = (_b = group.properties) === null || _b === void 0 ? void 0 : _b.selected_component;
    if (list === ComponentList.SUCTION_CUP || type === ComponentType.SUCTION_CUP)
        return extractSuctionCup(componentField, component, isObjectSurfaceOily);
    if (list === ComponentList.VACUUM_PUMP ||
        type === ComponentType.VACUUM_PUMP_CENTRAL ||
        type === ComponentType.VACUUM_PUMP_DECENTRAL)
        return extractVacuumPump(componentField, component);
    if (list === ComponentList.CUP_MOUNTING ||
        type === ComponentType.CUP_MOUNTING)
        return extractCupMounting(componentField, component);
    if (list === ComponentList.CUP_TECHNOLOGY ||
        type === ComponentType.CUP_TECHNOLOGY)
        return extractCupTechnology(componentField, component);
    return component;
};
export var getComponents = function (group, isObjectSurfaceOily) {
    var _a, _b, e_1, _c;
    var _d;
    /* Cups and pumps have no "none" option: a grip position or pump node without
     * one is removed instead. Mountings and technologies can be left out. */
    var suctionCupComponents = {};
    var vacuumPumpComponents = {};
    var noMountingValue = "".concat(ComponentList.CUP_MOUNTING, "_X");
    var cupMountingComponents = (_a = {},
        _a[noMountingValue] = {
            articleNumber: noCupMountingArticleNumber,
            value: noMountingValue,
            label: t("edit_grip_position.no_cup_mounting_selected"),
            link: "",
            valid: true,
            model: "test",
            volume: 1,
            diameter: 1,
            suctionCupCompatibility: ALWAYS_COMPATIBLE,
        },
        _a);
    var noTechnologyValue = "".concat(ComponentList.CUP_TECHNOLOGY, "_X");
    var cupTechnologyComponents = (_b = {},
        _b[noTechnologyValue] = {
            articleNumber: "no_technology",
            value: noTechnologyValue,
            label: t("edit_grip_position.no_cup_technology_selected"),
            link: "",
            valid: true,
            pigripCode: "00",
            cupTechId: "",
            volume: 1,
            diameter: 1,
            type: "None",
        },
        _b);
    try {
        for (var _e = __values(group.members), _f = _e.next(); !_f.done; _f = _e.next()) {
            var member = _f.value;
            if (!member.isGroup)
                continue;
            var subGroup = member;
            var component = getComponentFromTactonGroup(subGroup, isObjectSurfaceOily);
            if (!component)
                continue;
            var list = (_d = subGroup.properties) === null || _d === void 0 ? void 0 : _d.component_list;
            if (list === ComponentList.SUCTION_CUP) {
                suctionCupComponents[component.value] = component;
            }
            else if (list === ComponentList.VACUUM_PUMP) {
                vacuumPumpComponents[component.value] = component;
            }
            else if (list === ComponentList.CUP_MOUNTING) {
                cupMountingComponents[component.value] =
                    component;
            }
            else if (list === ComponentList.CUP_TECHNOLOGY) {
                cupTechnologyComponents[component.value] =
                    component;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        suctionCupComponents: suctionCupComponents,
        vacuumPumpComponents: vacuumPumpComponents,
        cupMountingComponents: cupMountingComponents,
        cupTechnologyComponents: cupTechnologyComponents,
    };
};
export var getSelections = function (group) {
    var _a, e_2, _b;
    var _c;
    var suctionCupSelections = {};
    var vacuumPumpSelectionsCentralized = {};
    var vacuumPumpSelectionsDecentralized = {};
    var cupMountingSelections = {};
    var cupTechnologySelections = {};
    var typeMaps = (_a = {},
        _a[ComponentType.SUCTION_CUP] = {
            list: ComponentList.SUCTION_CUP,
            selections: suctionCupSelections,
        },
        _a[ComponentType.VACUUM_PUMP_CENTRAL] = {
            list: ComponentList.VACUUM_PUMP,
            selections: vacuumPumpSelectionsCentralized,
        },
        _a[ComponentType.VACUUM_PUMP_DECENTRAL] = {
            list: ComponentList.VACUUM_PUMP,
            selections: vacuumPumpSelectionsDecentralized,
        },
        _a[ComponentType.CUP_MOUNTING] = {
            list: ComponentList.CUP_MOUNTING,
            selections: cupMountingSelections,
        },
        _a[ComponentType.CUP_TECHNOLOGY] = {
            list: ComponentList.CUP_TECHNOLOGY,
            selections: cupTechnologySelections,
        },
        _a);
    var subGroups = group.members;
    try {
        for (var subGroups_1 = __values(subGroups), subGroups_1_1 = subGroups_1.next(); !subGroups_1_1.done; subGroups_1_1 = subGroups_1.next()) {
            var subGroup = subGroups_1_1.value;
            if (!subGroup.isGroup)
                continue;
            var members = subGroup.members;
            var componentField = members[0];
            var type = (_c = subGroup.properties) === null || _c === void 0 ? void 0 : _c.selected_component;
            if (!type)
                continue;
            if (componentField.value === "".concat(typeMaps[type].list, "_X")) {
                typeMaps[type].selections[componentField.name] = null;
            }
            else {
                typeMaps[type].selections[componentField.name] = componentField.value;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (subGroups_1_1 && !subGroups_1_1.done && (_b = subGroups_1.return)) _b.call(subGroups_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return {
        suctionCupSelections: suctionCupSelections,
        vacuumPumpSelectionsCentralized: vacuumPumpSelectionsCentralized,
        vacuumPumpSelectionsDecentralized: vacuumPumpSelectionsDecentralized,
        cupMountingSelections: cupMountingSelections,
        cupTechnologySelections: cupTechnologySelections,
    };
};
